export default "__VITE_PUBLIC_ASSET__78a95d8b__"